import { analyticsUtils } from 'utils/analytics-utils';
import { KITCHEN_PRICE_PDP_ELEMENT_BLOCK } from './kitchen-price-pdp-constants';

type GAProductInfo = {
  productName: string;
  productId: string;
  productPrice: number;
  productPrevPrice: null;
  productBelong: 'LeroyMerlin';
};

export const addToCartGAEvent = (productInfo: GAProductInfo, elementName: string, elementText: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementBlock: KITCHEN_PRICE_PDP_ELEMENT_BLOCK,
    elementType: 'button',
    elementName,
    elementText,
    ...productInfo,
  });
};

export const navSlideClickGAEvent = (productInfo: GAProductInfo, elementText: string) => {
  analyticsUtils.sendEvent('GA:clickButton', {
    elementType: 'button',
    elementBlock: KITCHEN_PRICE_PDP_ELEMENT_BLOCK,
    elementName: 'mediaContent',
    elementText,
    ...productInfo,
  });
};
